<div class="main">
  <spb-test type="APPLICATION"></spb-test>
  <div class="holder">
    <div class="content">
      <div class="row">
        @if (borgoService.borgoPossible()) {
          <div>
            <div class="main-title">Borgo</div>
            <div [class]="{ 'negative': borgo().kalp < 0 }"
                 class="kalp-number">{{ borgo().kalp | number: '1.0-0' : 'sv' }}
            </div>
          </div>
        }
        <div [class]="{ 'right' : borgoService.borgoPossible() }">
          <div class="main-title">Egen portfölj</div>
          <div
            [class]="{ 'negative': sparbanken().kalp < 0 }"
            class="kalp-number">{{ sparbanken().kalp | number: '1.0-0' : 'sv' }}
          </div>
        </div>
      </div>
      <mat-tab-group class="row" mat-stretch-tabs>
        @if (borgoService.borgoPossible()) {
          <mat-tab label="Borgo">
            <ng-template matTabContent>
              <spb-kalp-display [kalp]="borgo().kalp"
                                [kalpylator]="borgo()"></spb-kalp-display>
            </ng-template>
          </mat-tab>
        }
        <mat-tab label="Egen portfölj">
          <ng-template matTabContent>
            <spb-kalp-display [kalp]="sparbanken().kalp"
                              [kalpylator]="sparbanken()"
                              title="Egen portfölj"></spb-kalp-display>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      <div class="row">
        @if (debtQuota() !== null && debtQuota()! > maxDebtQuota && borgoService.borgoPossible()) {
          <div
            class="warning">
            <p>Skuldkvoten överstiger {{ maxDebtQuota }} och krediten kan därför
              inte placeras hos Borgo när sökandes ålder
              är {{ age() }} år.</p>
          </div>
        }
      </div>
      <div class="row">
        <div class="sliders">
          <spb-slider
            (valueChange)="setIncome($event)"
            [initial]="sparbanken().monthlyIncome"
            [kalpylator]="sparbanken()"
            [max]="500 * 1000"
            [min]="0"
            fieldTitle="Inkomst"
            suffix="kr/månad"
          ></spb-slider>
          <spb-slider
            (valueChange)="setTotalLoan($event)"
            [initial]="newLoan()"
            [kalpylator]="sparbanken()"
            [max]="loanSliderMax()"
            [min]="10000"
            fieldTitle="Nya lån"
            suffix="kr"
          ></spb-slider>
          <spb-slider
            (valueChange)="calculate2p($event)"
            [kalpylator]="sparbanken()"
            [max]="10"
            [min]="0"
            fieldTitle="Ökad ränta"
            suffix="%"
          ></spb-slider>
        </div>
      </div>
    </div>
    <div class="help">
      <ul>
        @if (borgoService.borgoPossible()) {
          <li><strong>Stressning av månadsavgift</strong> till
            bostadsrättsförening vid högre ränteläge (>4,5%) för
            föreningens lån är ej
            med i beräkningarna. Manuell kostnad kan läggas in om högre
            ränteläge är aktuellt.
          </li>
        }
        <li>KALP kan kopieras och klistras in i <strong>Excel</strong>.</li>
        <li>Klicka i KALP för att visa <strong>detaljnivå</strong>.</li>
        <li>Använd <strong>Reglage</strong> för att simulera kunds inkomst, sökt
          lånebelopp och räntehöjningar.
          Simuleringen kan återställas.
        </li>
        <li>Ska uppgifter korrigeras kan man gå <a (click)="goToIncome()"
                                                   [routerLink]="backDestination"
        ><strong>tillbaka</strong></a> i
          processen. Vid respektive steg finns en beräkna knapp som tar en fram
          till KALP igen.
        </li>
        @if (borgoService.borgoPossible()) {
          <li>Om det blir <strong>underskott</strong>
            i KALP visas även KALP resultat för om kredit läggs i
            egen portfölj
            för att få
            kännedom om ansökan kan beredas vidare.
          </li>
        }

        @if (borgoService.borgoPossible()) {
          <li>KALP beräknas enligt
            schablon för ränta och amortering. På övriga objekt räknas
            amortering
            med 1%, på belåningsobjekt räknas amortering enligt amorteringskrav
            0-2% alt alternativregeln. <br/>
            Ex: <br/>
            Kund har 5.000.000 som ej omfattas och ett Alternativregellån på 100.000 –
            <br/>
            Alternativregellån på 10 år.
          </li>
        }

        @if (!borgoService.borgoPossible()) {
          <li>KALP beräknas enligt
            schablon för ränta och amortering. Amortering räknas enligt
            amorteringskrav 0-2 % på samtliga objekt.
          </li>
        }
      </ul>
    </div>
  </div>
  <div class="buttons">
    <button [routerLink]="backDestination" matButton="outlined">Tillbaka</button>
    <button (click)="reset()" matButton="filled">Börja om
    </button>
  </div>
</div>
